import React from 'react';

const CombinedEstimateCard = React.forwardRef(({ estimates, customerName, customerPhone }, ref) => {
  const grandTotal = estimates.reduce((sum, est) => sum + (est.total_amount || 0), 0);
  const totalGoldAmount = estimates.reduce((sum, est) => sum + (est.gold_amount || 0), 0);
  const totalStonesAmount = estimates.reduce((sum, est) => sum + (est.stones_amount || 0), 0);
  const totalMakingAmount = estimates.reduce((sum, est) => sum + (est.making_amount || 0), 0);

  return (
    <div ref={ref} style={{
      width: '600px',
      background: 'white',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif',
    }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #0f766e 0%, #0d9488 100%)',
        color: 'white',
        padding: '24px',
        textAlign: 'center',
      }}>
        <h1 style={{ margin: 0, fontSize: '28px', fontWeight: '700', letterSpacing: '2px' }}>JEWELFLOW</h1>
        <div style={{ height: '2px', background: 'rgba(255,255,255,0.3)', margin: '12px auto', width: '80%' }}></div>
        <div style={{ fontSize: '14px', marginTop: '8px', opacity: 0.9 }}>Combined Estimate</div>
        <div style={{ fontSize: '18px', fontWeight: '700', marginTop: '4px' }}>{customerName}</div>
        {customerPhone && <div style={{ fontSize: '13px', opacity: 0.8, marginTop: '2px' }}>{customerPhone}</div>}
        <div style={{ fontSize: '13px', opacity: 0.8, marginTop: '4px' }}>
          {estimates.length} items | {new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Kolkata' })}
        </div>
      </div>

      {/* Individual Estimates */}
      <div style={{ padding: '16px 24px' }}>
        {estimates.map((estimate, index) => (
          <div key={estimate.estimate_number} style={{
            border: '1px solid #e5e7eb',
            borderRadius: '10px',
            marginBottom: '12px',
            overflow: 'hidden',
          }}>
            {/* Estimate Header */}
            <div style={{
              background: '#f0fdfa',
              padding: '10px 16px',
              borderBottom: '1px solid #e5e7eb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
              <div>
                <div style={{ fontSize: '15px', fontWeight: '700', color: '#0f766e' }}>
                  {estimate.estimate_number}
                </div>
                {estimate.tag_number && (
                  <div style={{ fontSize: '12px', color: '#d97706', fontWeight: '600' }}>Tag: {estimate.tag_number}</div>
                )}
                <div style={{ fontSize: '12px', color: '#6b7280' }}>
                  {estimate.main_group && estimate.product
                    ? `${estimate.main_group} - ${estimate.product}`
                    : estimate.main_group || estimate.product || 'Jewelry'}
                  {' | '}{estimate.gold_purity}
                </div>
              </div>
              <div style={{
                fontSize: '18px',
                fontWeight: '800',
                color: '#059669',
              }}>
                ₹{Math.round(estimate.total_amount).toLocaleString('en-IN')}
              </div>
            </div>

            {/* Estimate Details */}
            <div style={{ padding: '10px 16px', fontSize: '13px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0' }}>
                <span style={{ color: '#6b7280' }}>Gross Wt: {estimate.gross_weight}g</span>
                <span style={{ color: '#6b7280' }}>Net Wt: {estimate.net_weight}g</span>
                <span style={{ color: '#6b7280' }}>Wastage: {estimate.wastage_percentage}%</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0' }}>
                <span style={{ color: '#6b7280' }}>Gold Rate: ₹{estimate.gold_rate?.toLocaleString('en-IN')}/g</span>
                <span style={{ color: '#0e7490', fontWeight: '600' }}>Gold: ₹{Math.round(estimate.gold_amount).toLocaleString('en-IN')}</span>
              </div>
              {estimate.stones && estimate.stones.length > 0 && (
                <div style={{ padding: '3px 0' }}>
                  <span style={{ color: '#7c3aed', fontWeight: '600' }}>
                    Stones ({estimate.stones.length}): ₹{Math.round(estimate.stones_amount).toLocaleString('en-IN')}
                  </span>
                  <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '2px' }}>
                    {estimate.stones.map((s, i) => `${s.name}: ${s.weight}ct`).join(' | ')}
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0' }}>
                <span style={{ color: '#6b7280' }}>Making: ₹{Math.round(estimate.making_amount).toLocaleString('en-IN')}</span>
                {estimate.other_charges > 0 && (
                  <span style={{ color: '#6b7280' }}>Other: ₹{Math.round(estimate.other_charges).toLocaleString('en-IN')}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Combined Summary */}
      <div style={{
        margin: '0 24px 16px',
        background: 'linear-gradient(135deg, #f0fdfa 0%, #e0f2fe 100%)',
        border: '2px solid #06b6d4',
        borderRadius: '12px',
        padding: '16px',
      }}>
        <div style={{ fontSize: '14px', fontWeight: '700', color: '#0e7490', marginBottom: '8px' }}>Summary</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '14px' }}>
          <span style={{ color: '#0e7490' }}>Total Gold</span>
          <span style={{ fontWeight: '700', color: '#0e7490' }}>₹{Math.round(totalGoldAmount).toLocaleString('en-IN')}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '14px' }}>
          <span style={{ color: '#0e7490' }}>Total Stones</span>
          <span style={{ fontWeight: '700', color: '#0e7490' }}>₹{Math.round(totalStonesAmount).toLocaleString('en-IN')}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '14px' }}>
          <span style={{ color: '#0e7490' }}>Total Making</span>
          <span style={{ fontWeight: '700', color: '#0e7490' }}>₹{Math.round(totalMakingAmount).toLocaleString('en-IN')}</span>
        </div>
      </div>

      {/* Grand Total */}
      <div style={{
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        padding: '20px',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '4px', opacity: 0.9 }}>
          GRAND TOTAL ({estimates.length} items)
        </div>
        <div style={{ fontSize: '36px', fontWeight: '800', letterSpacing: '1px' }}>
          ₹{Math.round(grandTotal).toLocaleString('en-IN')}
        </div>
        <div style={{ fontSize: '12px', marginTop: '8px', opacity: 0.8 }}>All inclusive with GST</div>
      </div>
    </div>
  );
});

CombinedEstimateCard.displayName = 'CombinedEstimateCard';

export default CombinedEstimateCard;
